module.exports = __webpack_public_path__ + "img/Thai Fa Power.d66e8f60.png";